import {css, StyleSheet} from 'aphrodite';
import moment from 'moment';
import React, {useState} from 'react';

import {assertAndContinue} from 'Asserts';
import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import {DateInput} from 'ui-library/inputs/DatetimeInput';
import Modal from 'ui-library/modals/Modal';
import * as DateUtil from 'util/DateUtil';

import {ProcessTaskListingGraphQL} from '../../../../graphql-fragments/processes/__generated/ProcessTaskListingGraphQL';

interface ProcessTaskScheduledOnEditorModalProps {
  onRequestSubmit: (date: string | null) => void;
  onRequestClose: () => void;
  items: Array<ProcessTaskListingGraphQL>;
}

export default function ProcessTaskScheduledOnEditorModal(
  props: ProcessTaskScheduledOnEditorModalProps
): JSX.Element {
  assertAndContinue(
    props.items.length > 0,
    'ProcessTaskScheduledOnEditorModal requires at least one selected item'
  );
  const allSameScheduledOnDate = props.items.every(
    (task) => task.scheduledOnDate === props.items[0].scheduledOnDate
  );
  const baseDate = allSameScheduledOnDate ? props.items[0].scheduledOnDate : null;
  const getCurrentValueText = (): string => {
    if (allSameScheduledOnDate) {
      return props.items[0].scheduledOnDate != null
        ? DateUtil.readableTime(props.items[0].scheduledOnDate, {showTime: false})
        : 'None';
    }
    return 'Multiple scheduled on dates';
  };

  const [date, setDate] = useState<string | null>(baseDate);
  return (
    <Modal
      title="Bulk update scheduled on date"
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        props.onRequestSubmit(date != null && moment(date, 'YYYY-MM-DD', true).isValid() ? date : null);
      }}
      buttons={[{text: 'Update', submit: true}]}
      scrollable={false}
      expandHeight={false}
    >
      <div className={css(styles.container)}>
        <span className={css(styles.field)}>
          <span className={css(styles.label)}>Current Value:</span>
          <span className={css(styles.current)}>
            <div data-test="ProcessTaskScheduledOnEditorModal-currentValue" className="u-ellipsis-text">
              {getCurrentValueText()}
            </div>
          </span>
        </span>
        <span className={css(styles.field)}>
          <span className={css(styles.label)}>New Value:</span>
          <DateInput
            placeholder="Date"
            autoFocus={true}
            onChange={(value: string) => {
              setDate(value);
            }}
            value={date ?? ''}
          />
        </span>
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
  },
  field: {
    flexGrow: 1,
  },
  label: {
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
  },
  current: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '8px',
  },
});
